module.exports = __webpack_public_path__ + "static/media/product_11.a1236d23.jpg";